import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
`
export const ButtonCreate = styled.button`
  font-weight: bold;
  user-select: none;
  display: flex;
  height: 100%;
  align-items: center;
  font-size: .8rem;
  margin-left: 0.5rem;
  margin-left: 0.5rem;
  padding: 0 1.5rem;
  color: #fff;
  cursor: pointer;
  justify-content: center;
  background-color: #0090D3;
  border-radius: 2rem;
  border: none;
  img{
    height: .8rem;
    margin-right: 0.4rem;
  }
  &.reverse{
      background-color: #ffffff;
      color: #0090D3;
      border: solid 1px #0090D3;
    }
    &.disable{
    background-color: #EBEBEB;
    cursor: not-allowed;
  }
`
export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 62.5vw;
    margin-top: 2.8vh;
    margin-left: 1.2vw;
    margin-right: 0.7vw;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`